import PurchaseYearPage from "./PurchaseYearPage"

export default PurchaseYearPage
